$(document).ready(function () {
  const initialHeight = 180;
  $('.one-whole .content').each(function () {
    const content = $(this);
    const actualHeight = content.get(0).scrollHeight;
    if (actualHeight > initialHeight) {
      content
        .addClass('fade-effect')
        .css('max-height', `${initialHeight}px`)
        .after('<button class="toggle-content-btn">Read More</button>');
      content.next('.toggle-content-btn').click(function () {
        const isExpanded = content.hasClass('expanded');
        if (isExpanded) {
          content
            .removeClass('expanded')
            .animate({ maxHeight: `${initialHeight}px` }, 300);
          $(this).text('Read More');
        } else {
          content
            .addClass('expanded')
            .animate({ maxHeight: content.get(0).scrollHeight }, 300);
          $(this).text('Read Less');
        }
      });
    }
  });
});

